// FILECONTENT_START src/common/modules/validator/index.ts
import I18n from "i18n-js";
import Joi, { CustomHelpers, LanguageMessages } from "joi";
import { get } from "lodash";

interface ExtendedAnySchema extends Joi.AnySchema {
  optionalArray(): this;
}

interface ExtendedJoi extends Joi.Root {
  optionalArray(): ExtendedAnySchema;
}

// @ts-ignore
const customJoi: ExtendedJoi = Joi.extend((joi: any) => {
  return {
    type: "optionalArray",
    base: joi.any(),
    coerce(value: any, helpers: CustomHelpers) {
      return { value: value === undefined || value === null ? [] : value };
    },
  };
});

export interface ValidationErrors {
  [id: string]: string;
}

export interface Rules {
  [id: string]: Joi.AnySchema | [Rules];
}

export interface Values {
  [id: string]: any;
}

function validate(
  rules: Rules,
  values: Values | undefined,
  translationCategory?: string
) {
  const messages = I18n.t("validation", {
    defaultValue: {},
  }) as unknown as LanguageMessages;
  let errors: ValidationErrors = {};

  Object.keys(rules).forEach(key => {
    const validator = rules[key];
    if (Array.isArray(validator)) {
      const items: any[] = values && values[key] ? values[key] : [];
      let _errors: any[] = [];
      let errorCount = 0;
      items.forEach(item => {
        // You have to put an Array.isArray(validator[0]) condition like above, thats it.
        if (Array.isArray(validator[0])) {
          const nestedItems: any[] = item || [];
          let nestedErrors: any[] = [];
          let nestedErrorCount = 0;
          nestedItems.forEach(nestedItem => {
            const _nestedResult = validate(
              //@ts-ignore
              validator[0][0],
              nestedItem,
              translationCategory
            );
            if (_nestedResult.success) {
              nestedErrors.push(null);
            } else {
              nestedErrorCount++;
              nestedErrors.push(_nestedResult.errors);
            }
          });
          if (nestedErrorCount > 0) {
            _errors.push(nestedErrors);
          } else {
            _errors.push(null);
          }
        } else {
          const _result = validate(validator[0], item, translationCategory);
          if (_result.success) {
            _errors.push(null);
          } else {
            errorCount++;
            _errors.push(_result.errors);
          }
        }
      });
      if (errorCount > 0) {
        //@ts-ignore
        errors[key] = _errors;
      }
    } else {
      const result = validator
        .messages(messages)
        .empty(null)
        .validate(get(values, key, null) /*, { allowUnknown: true }*/);
      if (result.error) {
        if (translationCategory) {
          errors[key] = result.error.message.replace(
            '"value"',
            I18n.t(`${translationCategory}.attributes.${key}`)
          );
        } else {
          errors[key] = result.error.message;
        }
      }
    }
  });

  return {
    success: Object.keys(errors).length === 0,
    errors,
  };
}

const Validator = {
  rule: customJoi,
  validate,
};

export default Validator;

// FILECONTENT_END src/common/modules/validator/index.ts
